import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { SqlModelingGitService } from './sql-modeling-git.service';

@Injectable({ providedIn: 'root' })
export class SqlModelingGitFactoryService extends AbstractGitFactoryService<SqlModelingGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: SqlModelingGitService,
    });
  }
}
